import React from 'react';
import { Button, Link, useRecordContext } from 'react-admin';

import { FEEDBACK } from '../../../constants/resources';
import { typeUser as userType, statuses } from '../constants';


export default (props) => {
	const { style } = props;
	const record = useRecordContext();
	if (!record) return null;

	const {
		typeUser, uuid, user, installationId,
	} = record;

	const isClientMessage = typeUser === userType.Client;

	const onClick = (event) => event.stopPropagation();

	const prefilledRecord = {
		uuid,
		typeUser: userType.Admin,
		status: statuses.unread,
		installationId,
	};

	return isClientMessage && (
		<Button
			label="Ответить"
			component={Link}
			style={style}
			/**
			 * значение следующего свойства местная версия eslint (или парсера babel-eslint)
			 * не переваривает,
			 * либо каментить и дизаблить eslint для файла для временных коммитов,
			 * либо git commit --no-verify
			 */
			to={{
				pathname: `/${FEEDBACK}/create`,
				state: { record: user ? { ...prefilledRecord, user } : prefilledRecord },
			}}
			onClick={onClick}
		/>
	);
};
